/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Hidden, Typography2, useTheme } from '@coursera/cds-core';

import { ProgressBar } from 'bundles/skills-common';

import _t from 'i18n!nls/program-skills-objectives';

type Props = {
  skillName: string;
  skillScore: number;
  maxScore: number;
  segments: number[];
};

const LevelSetsResultProgressBar = ({ skillName, skillScore, maxScore, segments }: Props) => {
  const theme = useTheme();
  return (
    <div
      css={{ width: '100%', marginTop: theme.spacing(16) }}
      aria-label={_t('Skill progress: #{skillName}, score: #{skillScore} of #{maxScore}', {
        skillName,
        skillScore,
        maxScore,
      })}
    >
      <ProgressBar aria-hidden score={skillScore} maxScore={maxScore} segments={segments} />
      <Hidden xsDown css={{ width: '100%', marginBottom: theme.spacing(24) }}>
        <div aria-hidden css={{ display: 'flex', width: '100%', position: 'relative' }}>
          {[...segments, maxScore].map((segment) => (
            <Typography2
              key={segment}
              color="supportText"
              variant="subtitleMedium"
              component="p"
              css={{
                position: 'absolute',
                left: `${Math.floor((100 * segment) / maxScore)}%`,
                transform: 'translate(-50%, -10px) translateX(-6px)', // Not sure why we need to move an extra 6px to be fully centered. Maybe from some margin or the capRadius of the ProgressBar
              }}
            >
              {segment}
            </Typography2>
          ))}
        </div>
      </Hidden>
    </div>
  );
};

export default LevelSetsResultProgressBar;
